import { ColumnDef } from '@tanstack/react-table';
import CheckBox from '../../../../../../../Guidance/components/Common/UI/CheckBox';

export interface AccountChecksRes {
  id: number;
  date: string;
  number: string;
  amount: string;
  image: string;
}

export const accountChecksCol: ColumnDef<AccountChecksRes>[] = [
  {
    accessorKey: 'id',
    header: () => <CheckBox id="#" label="" />,
  },
  {
    enableSorting: true,
    accessorKey: 'date',
    header: 'Check Date',
  },
  {
    enableSorting: true,
    accessorKey: 'number',
    header: 'Check Date',
  },
  {
    enableSorting: true,
    accessorKey: 'amount',
    header: 'Check Amount',
  },
  {
    enableSorting: true,
    accessorKey: 'image',
    header: 'View Check Image',
  },
];
